import { useState, useEffect } from 'react'

/**
 * Fetches all pages from a paginated list endpoint.
 * @param {(params: { page: number, limit: number }) => Promise<{ items?: unknown[], pagination?: { hasNextPage?: boolean } }>} fetchPage
 */
export function useAllPaginatedItems(fetchPage, { pageSize = 100, maxPages = 500 } = {}) {
  const [items, setItems] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    let cancelled = false

    const loadAll = async () => {
      try {
        setLoading(true)
        setError(null)
        const all = []
        let page = 1
        let hasNext = true

        while (hasNext) {
          const response = await fetchPage({ page, limit: pageSize })
          const pageItems = response?.items || []
          all.push(...pageItems)
          hasNext = response?.pagination?.hasNextPage === true
          page += 1
          if (page > maxPages) break
        }

        if (!cancelled) setItems(all)
      } catch (err) {
        if (!cancelled) {
          setError(err)
          setItems([])
        }
      } finally {
        if (!cancelled) setLoading(false)
      }
    }

    loadAll()
    return () => {
      cancelled = true
    }
  }, [fetchPage, pageSize, maxPages])

  return { items, loading, error }
}
